"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrLinkWrapper = exports.FdrHelpOverlayBoxWrap = exports.FdrInfoCardImage = exports.FdrInfoCardContentWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const components_common_mixins_1 = require("@hotelplan/components.common.mixins");
const fdr_regular_basis_fdr_image_1 = require("@hotelplan/fdr.regular.basis.fdr-image");
const fdr_regular_basis_fdr_route_1 = require("@hotelplan/fdr.regular.basis.fdr-route");
exports.FdrInfoCardContentWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)(components_common_mixins_1.card, {
    border: '1px solid',
    borderColor: 'borderGreyFifth',
    py: [3, 4],
    px: [3, 4],
    height: ['auto', '100%'],
    pt: [4, '90px'],
}));
exports.FdrInfoCardImage = (0, styled_components_1.default)(fdr_regular_basis_fdr_image_1.FdrImage)((0, util_theme_sxc_1.sx2CssThemeFn)({
    width: ['24px', '34px'],
    height: ['24px', '34px'],
}));
exports.FdrHelpOverlayBoxWrap = styled_components_1.default.div(({ theme }) => theme.helpOverlay.wrapper, ({ boxesCount, theme: { media } }) => ({
    width: '100%',
    [media.tablet]: {
        width: `${(1 / boxesCount) * 100}%`,
    },
}));
exports.FdrLinkWrapper = (0, styled_components_1.default)(fdr_regular_basis_fdr_route_1.FdrRoute)({
    width: '100%',
    height: '100%',
    '&:hover': {
        color: 'inherit',
    },
});
//# sourceMappingURL=fdr-help-overlay.styles.js.map